import { render, staticRenderFns } from "./realBalance.vue?vue&type=template&id=4b978903"
import script from "./realBalance.vue?vue&type=script&lang=js"
export * from "./realBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports